import { pipe } from 'fp-ts/function';
import { array } from 'fp-ts';
import { Formula, FormulaType } from '@mews-commander/data-access';

export const evaluateFormula = (formula: Formula): boolean => {
    switch (formula.value.discriminator) {
        case FormulaType.Constant:
            return formula.value.value.value;
        case FormulaType.Variable:
            return true;
        case FormulaType.Negation:
            return !evaluateFormula(formula.value.value.formula);
        case FormulaType.Disjunction:
            return pipe(
                formula.value.value.formulas,
                array.map((innerFormula) => evaluateFormula(innerFormula)),
                array.some((evaluated) => evaluated === true)
            );
        case FormulaType.Conjunction:
            return pipe(
                formula.value.value.formulas,
                array.map((innerFormula) => evaluateFormula(innerFormula)),
                array.every((evaluated) => evaluated === true)
            );
        default:
            return false;
    }
};
